<template>
  <button
    v-if="icon && !unabled"
    :class="checked ? 'btn-success' : 'btn-info'" :title="checked ? 'Registrar ausência' : 'Registrar presença'"
    class="btn btn-fill btn-icon"
    @click="handleChangeCheckInWinner()">
    <i class="ti-check"></i>
  </button>

 <button
   v-else-if="!icon && !unabled"
   @click="handleChangeCheckInWinner()"
   class="btn btn-fill btn-block"
   :class="checked ? 'btn-warning' : 'btn-success'">
   {{ checked ? 'Registrar ' + 'ausência ' + 'no ' + 'sorteio' : 'Registrar ' + 'presença ' + 'no ' + 'sorteio' }}
 </button>
</template>

<script>
  import Couchdb from 'src/services/Couchdb'
  import {mapActions} from 'vuex'

  export default {
    name: 'ticket-check-in',
    props: {
      ticket: {
        required: true,
        type: Object
      },
      icon: {
        default: false
      },
      eventId: {
        default: false
      }
    },
    watch: {
      ticket () {
        this.checked = this.ticket.checkIn
      }
    },
    data () {
      return {
        saving: false,
        checked: false
      }
    },
    methods: {
      ...mapActions('tickets', ['setCheckIn', 'getTicketsByEvent']),
      handleChangeCheckInWinner () {
        this.saving = true

        let _ticket = Object.assign({}, this.ticket)
        _ticket.checkIn = !_ticket.checkIn

        delete _ticket.customer
        delete _ticket.event
        delete _ticket.stock

        Couchdb.connection('default').collection('tickets')
          .updateWithView({ddoc: 'tickets-by-id', view: 'tickets-by-id', payload: _ticket, database: 'default'})
          .then(() => {
            this.$notify({
              message: 'Presença registrada com sucesso.',
              type: 'success'
            })
            this.checked = _ticket.checkIn
            this.saving = false
            this.setCheckIn({
              id: _ticket._id,
              check: _ticket.checkIn
            })
            if (this.eventId) {
              this.getTicketsByEvent(this.eventId)
            }
          })
          .catch(err => {
            console.log(err)
            this.$notify({
              message: 'Ocorreu algum problema ao registrar a presença. Entre em contato com o suporte.',
              type: 'danger'
            })
            this.saving = false
          })
      }
    },
    computed: {
      unabled: function () {
        return this.saving || !this.ticket.winner || !this.$can('tickets.checkin')
      }
    },
    mounted () {
      this.checked = this.ticket.checkIn
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Tickets/Actions/TicketCheckIn.vue